"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'payment.search.placeholder': '按会话ID、描述、邮箱搜索付款...',
};
